import { createAsyncThunk } from '@reduxjs/toolkit';
import { AXIOS_RESERVATION } from '../../../util/axiosInterceptors';

const createEvent = createAsyncThunk(
  'meeting/createEvent',
  async (state, { rejectWithValue, getState }) => {
    try {
      const { signIn, meeting } = getState();
      const body = { ...state };
      const userData = signIn?.userData;
      if (!meeting.calendarChannels.length > 0) {
        throw { response: { data: { message: 'Channel not found' } } };
      }
      const { calendarId } = meeting.calendarChannels[0];
      // if (userData?.firstName && userData?.lastName) {
      //   body.userName = `${userData?.firstName} ${userData?.lastName}`;
      // } else if (userData?.firstName && !userData?.lastName) {
      //   body.userName = userData?.firstName;
      // }

      if (userData.email) {
        body.email = userData.email;
        const res = await AXIOS_RESERVATION.post(
          '/google-calendar-events/insert-event',
          body,
          { params: { calendarId, meetingCategory: meeting.meetingCategory } },
        );
        return res.data;
      }
      throw { response: { data: { message: 'User Email Not Found' } } };
    } catch (error) {
      console.log(error?.response?.data, 'error?.res?.data');
      if (error?.response?.data?.message) {
        alert(error?.response?.data?.message);
      }
      throw rejectWithValue('');
    }
  },
);

const findEvents = createAsyncThunk(
  'meeting/findEvent',
  async (state, { rejectWithValue, getState }) => {
    try {
      const { meeting, signIn } = getState();
      const userData = signIn?.userData;
      if (!meeting.calendarChannels.length > 0) {
        throw { response: { data: { message: 'Channel not found' } } };
      }

      const { calendarId } = meeting.calendarChannels[0];
      const res = await AXIOS_RESERVATION.get(
        '/google-calendar-events/get-event',
        {
          params: {
            calendarId,
            meetingCategory: meeting.meetingCategory,
            email: userData?.email || '',
          },
        },
      );
      return res.data;
    } catch (error) {
      console.log(error?.res?.data, 'error?.res?.data');
      throw rejectWithValue('');
    }
  },
);

const findCalendarChannel = createAsyncThunk(
  'meeting/findCalendarChannel',
  async (state, { rejectWithValue, getState }) => {
    try {
      const res = await AXIOS_RESERVATION.get(
        '/google-calendar-events/calendar-channels',
      );
      return res.data;
    } catch (error) {
      console.log(error?.res?.data, 'error?.res?.data');
      throw rejectWithValue('');
    }
  },
);

export const meetingApis_ = {
  createEvent,
  findEvents,
  findCalendarChannel,
};
